/** Shortest time a notification stays on screen. */
export const AUTO_HIDE_MIN_MS = 6000;

/** Reading time added per character, so long messages stay up long enough to read. */
export const AUTO_HIDE_PER_CHAR_MS = 50;

/** Longest time a notification stays on screen before auto-hiding. */
export const AUTO_HIDE_MAX_MS = 20000;
